module.exports = __webpack_public_path__ + "static/media/stars-four-point-five.77b430f7.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/components/resources/stars-four-point-five.svg
// module id = 3444
// module chunks = 0